import { startOfDay } from 'date-fns';

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Formats a Date to an ISO string with the local timezone offset (e.g. 2025-02-13T00:00:00+01:00).
 */
export const toISOStringWithTimezone = (date: Date): string => {
    const offset = -date.getTimezoneOffset();
    const sign = offset >= 0 ? '+' : '-';
    const absOffset = Math.abs(offset);
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
    const minutes = String(absOffset % 60).padStart(2, '0');
    const offsetStr = `${sign}${hours}:${minutes}`;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d}T${h}:${min}:${s}${offsetStr}`;
};

/**
 * Parses a DateInput value (YYYY-MM-DD) to a ZonedDateTime ISO string at start of day in local timezone.
 */
export const parseDateToStartOfDayIsoWithTimezone = (
    value: string | Date | null | undefined
): string | null => {
    if (value == null || value === '') return null;

    let date: Date;
    if (value instanceof Date) {
        date = startOfDay(value);
    } else if (dateRegex.test(value)) {
        const [y, m, d] = value.split('-').map(Number);
        date = startOfDay(new Date(y, m - 1, d));
    } else {
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return null;
        date = startOfDay(parsed);
    }

    return toISOStringWithTimezone(date);
};

/**
 * Formats a ZonedDateTime ISO string back to YYYY-MM-DD for DateInput display.
 */
export const formatIsoToLocalDateString = (
    value: string | Date | null | undefined
): string | null => {
    if (value == null || value === '') return null;
    if (typeof value === 'string' && dateRegex.test(value)) return value;

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};
